// src/components/HeaderBar.jsx
import React from "react";

export default function HeaderBar({ gameweek = 12, minutesAgo = 0 }) {
  let updatedText;

  if (minutesAgo <= 0) {
    updatedText = "Updated just now";
  } else if (minutesAgo < 60) {
    updatedText = `Updated ${minutesAgo} min${minutesAgo === 1 ? "" : "s"} ago`;
  } else {
    const hours = Math.floor(minutesAgo / 60);
    updatedText = `Updated ${hours} hour${hours === 1 ? "" : "s"} ago`;
  }

  return (
    <header className="headerBar">
      <div className="brandTitle">⚽ Fantasy Premier Chat</div>
      <div className="headerInfo">
        <span className="gwInfo">Gameweek {gameweek}</span>
        <span className="lastUpdated">{updatedText}</span>
      </div>
    </header>
  );
}
